import { createConfirmation } from "react-confirm";
import ChooseTypeDialog from "./ChooseTypeDialog";

export const showChooseTypeDialog = createConfirmation(ChooseTypeDialog);
